import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button } from '../../root/components/common'
import CustomStepper from '../../root/components/common/stepper'
import { makeStyles } from '@material-ui/core/styles'
import SbuTermsAndConditons from './sbu-flow/terms-and-conditions'

export default function HotSwapFlowStepper({
    steps,
    handleConfirm,
    setSelectedSwapOption,
    isSwapByUserFlow = false,
    isCheckedTermsAndConditions = true,
    handleCheckBoxClick
}) {
    const firstStep = 0
    const [activeStep, setActiveStep] = useState(firstStep)

    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const isLastStep = useMemo(() => {
        return activeStep === (steps?.length ?? 0) - 1
    }, [activeStep, steps])

    async function handleNext() {
        const currentStep = steps[activeStep]

        if (currentStep.validate) {
            const isValid = await currentStep.validate()
            if (isValid) {
                setActiveStep(activeStep + 1)
            }
        } else {
            setActiveStep(activeStep + 1)
        }
    }

    function handleBack() {
        if (activeStep > firstStep) {
            setActiveStep(activeStep - 1)
            return
        }

        setSelectedSwapOption(null)
    }

    return (
        <div className={classes.wrapper}>
            <CustomStepper steps={steps} activeStep={activeStep} />
            <div>{steps?.[activeStep]?.step}</div>
            {isLastStep && isSwapByUserFlow && (
                <SbuTermsAndConditons
                    handleCheckBoxClick={handleCheckBoxClick}
                />
            )}
            <div className={classes.buttons}>
                <Button reverted onClick={handleBack}>
                    {locale.common.back}
                </Button>
                {!isLastStep && (
                    <Button onClick={handleNext}>{locale.common.next}</Button>
                )}
                {isLastStep && (
                    <Button
                        onClick={handleConfirm}
                        disabled={!isCheckedTermsAndConditions}
                    >
                        {locale.common.confirm}
                    </Button>
                )}
            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        alignItems: 'center'
    },
    buttons: {
        display: 'flex',
        gap: '12px'
    }
}))
